import { render, staticRenderFns } from "./GrobbulusComponent.vue?vue&type=template&id=fecf334c&"
import script from "./GrobbulusComponent.vue?vue&type=script&lang=js&"
export * from "./GrobbulusComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports